export const ACTION = {
    LOGIN : 'LOGIN',
    LOGOUT: 'LOGOUT',
}

export const login = (user) => ({ type: ACTION.LOGIN, payload: { user } });
export const logout = () => ({ type: ACTION.LOGOUT });